import CustomDateTimePicker from "./../../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import {
  getCustomCalendarDate,
  getFutureDate,
  getLocaleDate,
} from "./../../../../utils";

const Title = ({ data }) => {
  return (
    <div className="text-center">
      {data.name && (
        <h2 className="fw-bold">{data.name ?? data.description}</h2>
      )}
      {data.description_extra && <p>{data.description_extra}</p>}
    </div>
  );
};

const PreviewParamsOperator = ({ data }) => {
  let render = null;

  switch (data?.type) {
    case "radiobutton":
      render = <RadioButtonStep data={data} />;
      break;
    case "text":
      render = <TextStep data={data} />;
      break;
    case "multiplechoice":
      render = <MultipleChoiceStep data={data} />;
      break;
    case "datetime":
      render = <DateTimeStep data={data} />;
      break;
    case "number":
      render = <NumberStep data={data} />;
      break;
    case "switch":
      render = <SwitchStep data={data} />;
      break;
    case "item":
      render = <ItemStep data={data} />;
      break;

    default:
      render = null;
      break;
  }
  return render;
};

export default PreviewParamsOperator;

const RadioButtonStep = ({ data }) => {
  const list = data.list?.split("،");
  return (
    <div className="container">
      <Title data={data} />

      {list.map((item, index) => (
        <label htmlFor={index} className="select_item" key={item}>
          <span>{item}</span>
          <input
            type="radio"
            value={index}
            name={data.parameter}
            id={index}
            disabled
          />
        </label>
      ))}
    </div>
  );
};

const TextStep = ({ data }) => {
  return (
    <div className="container">
      <Title data={data} />
      <div>
        <textarea
          className="form-control p-4 shadow"
          id={data.parameter}
          placeholder={data.description}
          disabled
          style={{ height: "50vh" }}
        />
      </div>
      <br />
    </div>
  );
};

const MultipleChoiceStep = ({ data }) => {
  const list = data.list?.split("،");
  return (
    <>
      <div className="container">
        <Title data={data} />

        <select disabled className="form-control" id="multiplechoice">
          <option value="">{data.description} را انتخاب کنید</option>
          {list.map((item, index) => (
            <option key={item + index} disabled>
              {item}
            </option>
          ))}
        </select>
      </div>
      <br />
    </>
  );
};

const NumberStep = ({ data }) => {
  return (
    <>
      <div className="container">
        <Title data={data} />
        <div className="d-flex justify-content-center">
          <input
            type="number"
            name={data.parameter}
            id={data.parameter}
            className="form-control text-center w-25"
            disabled
            min={data.min}
            max={data.max}
          />
        </div>
      </div>
      <br />
    </>
  );
};

const SwitchStep = ({ data }) => {
  return (
    <>
      <div className="container">
        <Title data={data} />
        <label htmlFor={data.parameter} className="select_item">
          <span title={data.description}>{data.description_extra}</span>

          <label className="switch">
            <input
              type="checkbox"
              name={data.parameter}
              id={data.parameter}
              disabled
            />
            <span className="slider round"></span>
          </label>
        </label>
      </div>

      <br />
    </>
  );
};

const ChoicePersonnel = () => {
  return (
    <>
      <Title
        data={{
          name: "نوع نیروی مورد نیاز خود را مشخص کنید:",
          description: "",
          description_extra: "",
        }}
      />

      <label htmlFor="need_special_personnel_true" className="select_item">
        <span>متخصص ویژه</span>
        <input
          type="radio"
          name="need_special_personnel"
          id="need_special_personnel_true"
          disabled
        />
      </label>

      <label htmlFor="need_special_personnel_false" className="select_item">
        <span>متخصص عادی</span>
        <input
          type="radio"
          name="need_special_personnel"
          id="need_special_personnel_false"
          disabled
        />
      </label>

      <h4>تفاوت متخصص ویژه و متخصص عادی:</h4>
      <p className="card card-body mb-1">
        <span>هزینه خدمت:</span>{" "}
        <span className="text-muted">از لحاظ هزینه ای تفاوتی وجود ندارد.</span>
      </p>
      <p className="card card-body mb-1">
        <span>عملکرد متخصص:</span>{" "}
        <span className="text-muted">
          از لحاظ عملکرد، متخصصین ویژه سابقه همکاری بیشتر از یک سال با کارباما
          دارند و همچنین دارای امتیاز بالای 4.8، دارای تخصص فنی بالا، مسئولیت
          پذیری و پاسخگویی مناسب هستند و سایر فیلتر های کارباما را دریافت نموده
          اند.
        </span>
      </p>
      <p className="card card-body mb-1">
        <span>ثبت سفارش:</span>{" "}
        <span className="text-muted">
          به دلایل ذکر شده متخصص ویژه تعداد سفارشات بالایی در طول روز دارد و شما
          در فرایند ثبت سفارش فقط قادر به انتخاب تاریخ دریافت خدمت هستید و ساعت
          دقیق انجام خدمت توسط متخصص ویژه با هماهنگی با شما در تماس تلفنی تعیین
          خواهد شد.
        </span>
      </p>
      <br />
    </>
  );
};

const DateTimeStep = ({ data }) => {
  const clockOptions = [];
  for (
    let index = data.start_hour;
    index < data.end_hour;
    index += data.interval
  ) {
    clockOptions.push({
      value: index,
      label: `${index} تا ${index + data.interval}`,
    });
  }

  const localeDate = getLocaleDate(true);
  const futureDate = getFutureDate(20);

  const minDate = {
    year: localeDate.year,
    month: localeDate.month,
    day: localeDate.day,
  };
  const maxDate = {
    year: futureDate.year,
    month: futureDate.month,
    day: futureDate.day,
  };

  return (
    <div className="container">
      <ChoicePersonnel />

      <Title data={data} />

      <div className="row" id="date_time">
        <div className="col-12 col-sm">
          <label>تاریخ</label>
          <CustomDateTimePicker
            disabled
            type="single"
            placeholder="روز را انتخاب کنید"
            onChange={(e) =>
              e &&
              (document.getElementById("calendar").value =
                getCustomCalendarDate(e))
            }
          />

          {/* For save Calendar value */}
          <input type="hidden" id="calendar" value="" />
        </div>
        <div className="col-12 col-sm">
          <label>ساعت</label>
          <select disabled className="form-control" id="clock">
            <option value="" disabled hidden>
              ساعت را انتخاب کنید
            </option>
            {clockOptions.map((option) => (
              <option key={option.value} disabled>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <br />
    </div>
  );
};

const ItemStep = ({ data }) => {
  // Render Element (param)
  const renderParam = (param, index) => {
    let render = null;

    switch (param.type) {
      case "switch":
        render = (
          <label htmlFor={param.parameter} className="select_item">
            <span title={param.description}>{param.name}</span>

            <label className="switch">
              <input
                type="checkbox"
                defaultChecked={param.default}
                name={param.parameter}
                id={param.parameter}
                disabled
              />
              <span className="slider round"></span>
            </label>
          </label>
        );
        break;
      case "number":
        render = (
          <label htmlFor={param.parameter} className="select_item">
            <span className="fs-4" title={param.description}>
              {param.name}
            </span>
            <input
              type="number"
              name={param.parameter}
              id={param.parameter}
              className="form-control text-center w-25"
              min={param.min}
              max={param.max}
              disabled
            />
          </label>
        );
        break;
      case "radiobutton":
        const radioList = param.list?.split("،");
        render = (
          <div className="container">
            <Title data={param} />

            {radioList.map((item, _index) => (
              <label
                htmlFor={item + _index}
                className="select_item"
                key={item + _index}
              >
                <span>{item}</span>
                <input
                  type="radio"
                  value={_index}
                  name={param.parameter}
                  id={item + _index}
                  disabled
                />
              </label>
            ))}
          </div>
        );
        break;

      default:
        render = null;
        break;
    }
    return <>{render}</>;
  };

  return (
    <div className="container">
      <Title data={data} />
      {data.params?.map((param, index) => (
        <div key={param.order + param.parameter}>
          {renderParam(param, index)}
        </div>
      ))}
      <br />
    </div>
  );
};
